<ion-header>
  <ion-toolbar>
    <ion-title>Choose keg</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="newKegModal()" color="success">New</ion-button>
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid style="height: 100%; display: flex; flex-flow: column">
    <ion-row>
      @for (keg of kegs(); track keg; let i = $index) {
        <ion-col
          size-xs="12"
          size-md="6"
          >
          <ion-card
            button="true"
            class="ion-no-margin ps-h-100"
            [attr.disabled]="isKegDisabled(isPremium(), i) ? 'disabled' : null"
            (click)="selectKeg(keg, taps())"
            [ngClass]="{'card-active': tap.kegId === keg.id}"
            >
            <ion-card-content>
              <ion-item lines="none">
                <ion-thumbnail slot="start">
                  @if (keg?.container === 'PubKeg' || !keg?.container) {
                    <app-keg-svg
                      [item]="keg"
                    ></app-keg-svg>
                  }
                  @if (keg?.container === 'CornyKeg') {
                    <app-cornykeg-svg
                      [item]="keg"
                    ></app-cornykeg-svg>
                  }
                  @if (keg?.container === 'CornyKeg12') {
                    <app-cornykeg12-svg
                      [item]="keg"
                    ></app-cornykeg12-svg>
                  }
                  @if (keg?.container === 'CornyKeg09') {
                    <app-cornykeg09-svg
                      [item]="keg"
                    ></app-cornykeg09-svg>
                  }
                </ion-thumbnail>
                <ion-text>
                  <h2>{{ keg.name }}</h2>
                  @if (keg.id) {
                    <ul class="ion-item-list list-inline-note">
                      @if (!!tapExists(keg.id, taps())) {
                        <li>
                          <ion-icon src="assets/icons/flat/beer/tap.svg"></ion-icon>
                          <span>{{ getTapName(keg.id, taps()) }}</span>
                        </li>
                      }
                      @if (!!keg.beverage?.name) {
                        <li>
                          <ion-icon
                            src="assets/icons/flat/beer/glass-mug-2.svg"
                          ></ion-icon>
                          <span>{{ keg.beverage?.name }}</span>
                        </li>
                      }
                      @if (!!!!getPlaatoName(keg.id, taps())) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/plaato-logo3.svg"
                          ></ion-icon>
                          <span> {{ getPlaatoName(keg.id, taps()) }}</span>
                        </li>
                      }
                      @if (!!getKegtronName(keg.id, taps())) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/kegtron-logo.svg"
                          ></ion-icon>
                          <span> {{ getKegtronName(keg.id, taps()) }}</span>
                        </li>
                      }
                      @if (!!getCustomKegMonName(keg.id, taps())) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/custom-keg-monitor.svg"
                          ></ion-icon>
                          <span> {{ getCustomKegMonName(keg.id, taps()) }}</span>
                        </li>
                      }
                    </ul>
                  }
                </ion-text>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      }
    </ion-row>
  </ion-grid>
</ion-content>
